import React, { createContext, useState, useEffect } from 'react';
import { getSelfInfo } from '../services/api';  // 假设有这个 API 方法
import { useNavigate } from 'react-router-dom';

export const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchUserInfo = async () => {
      const token = localStorage.getItem('token');
      if (token) {
        try {
          const response = await getSelfInfo();  // 获取用户信息
          setUser({ ...response.data, token });
        } catch (error) {
          console.error('Error fetching user info:', error);
          localStorage.removeItem('token');
        }
      }
      setLoading(false);
    };

    fetchUserInfo();
  }, []);

  const login = async (token) => {
    localStorage.setItem('token', token);
    try {
      const response = await getSelfInfo();  // 登录后立即获取用户信息
      setUser({ ...response.data, token });
    } catch (error) {
      console.error('Error fetching user info after login:', error);
    }
  };

  const logout = () => {
    localStorage.removeItem('token');
    setUser(null);
    navigate('/login');
  };

  return (
    <AuthContext.Provider value={{ user, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
};